import textsES from '../languages/header/es.json' 

export const getHeaderTexts = () => {
	return textsES
}
